import { DatePipe } from "@angular/common";
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'app/auth/auth.service';
import * as faceapi from 'face-api.js';
@Component({
  selector: 'app-image-analyzer',
  templateUrl: './image-analyzer.component.html',
  styleUrls: ['./image-analyzer.component.scss']
})
export class ImageAnalyzerComponent implements OnInit {
  currentFacingMode: 'user' | 'environment' = 'environment';
  selectedImage: string | ArrayBuffer | null = null;
  @ViewChild('video', { static: false }) video!: ElementRef<HTMLVideoElement>;
  @ViewChild('canvas', { static: false }) canvas!: ElementRef<HTMLCanvasElement>;
  showCamera = false;
  private stream: MediaStream | null = null;
  isLoggedIn = false;
  username = '';
  password = '';
  loginError = '';
  loginSuccess = ''; // <-- NEW
  showSuccessMessage = false;
  starttime: any = '';
  endtime: any = '';
  constructor(private autherservice: AuthService, private http: HttpClient, private dialog: MatDialog, private datePipe: DatePipe) { }
async ngOnInit(): Promise<void> {
  // await Promise.all([
  //   faceapi.nets.tinyFaceDetector.loadFromUri('./assets/models'),
  //   faceapi.nets.faceLandmark68Net.loadFromUri('./assets/models'),
  //   faceapi.nets.tinyYolov2.loadFromUri('./assets/models') 
  // ]);
}



  analysisResult: any = null;
  userFeedback: string = '';

  openCameraInput(cameraInput: HTMLInputElement) {
    cameraInput.click(); // This opens mobile camera using input
  }


  openCamera() {
    this.showCamera = true;
    this.startCamera();

  }
  startCamera() {
  const constraints = {
    video: {
      facingMode: this.currentFacingMode
    },
    audio: false
  };

  navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
    this.stream = stream;
    const video = this.video.nativeElement;
    video.srcObject = stream;
    video.muted = true;
    video.setAttribute('playsinline', 'true');

    video.onloadedmetadata = () => {
      video.play().catch(err => console.error("Play error:", err));
    };
  }).catch((err) => {
    console.error("Camera error:", err);
  });
}


  // startCamera() {
  //   const constraints = {
  //     video: { facingMode: this.currentFacingMode }
  //   };

  //   navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
  //     this.stream = stream;
  //     this.video.nativeElement.srcObject = stream;
  //     this.video.nativeElement.play();
  //   }).catch((err) => {
  //     console.error("Camera error:", err);
  //   });
  // }
  
  // takePhoto() {
  //   const video = this.video.nativeElement;
  //   const canvas = this.canvas.nativeElement;
  //   const context = canvas.getContext('2d');

  //   canvas.width = video.videoWidth;
  //   canvas.height = video.videoHeight;

  //   if (context) {
  //     context.drawImage(video, 0, 0, canvas.width, canvas.height);
  //     this.selectedImage = canvas.toDataURL('image/png'); 
  //   }

  //   this.stopCamera(); 
  // }
  takePhoto() {
  const video = this.video.nativeElement;
  const canvas = this.canvas.nativeElement;
  const context = canvas.getContext('2d');

  if (video.videoWidth > 0 && video.videoHeight > 0) {
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    context?.drawImage(video, 0, 0, canvas.width, canvas.height);
    this.selectedImage = canvas.toDataURL('image/png');

    // Small delay ensures iPhone doesn't blank canvas
    setTimeout(() => {
      this.stopCamera();
    }, 200);
  } else {
    alert("Camera not ready. Please wait a second.");
  }
}


// async takePhoto() {
//   const video = this.video.nativeElement;
//   const canvas = this.canvas.nativeElement;
//   const ctx = canvas.getContext('2d');
//   if (video.readyState < 2) {
//     await new Promise(resolve => {
//       video.onloadedmetadata = () => resolve(true);
//     });
//   }

//   const detection = await faceapi
//     .detectSingleFace(video, new faceapi.TinyFaceDetectorOptions())
//     .withFaceLandmarks();

//   if (detection) {
//     const landmarks = detection.landmarks;
//     const leftEye = landmarks.getLeftEye();
//     const rightEye = landmarks.getRightEye();

//     const points = [...leftEye, ...rightEye];
//     const minX = Math.max(0, Math.min(...points.map(p => p.x)) - 20);
//     const maxX = Math.min(video.videoWidth, Math.max(...points.map(p => p.x)) + 20);
//     const minY = Math.max(0, Math.min(...points.map(p => p.y)) - 20);
//     const maxY = Math.min(video.videoHeight, Math.max(...points.map(p => p.y)) + 20);

//     const width = maxX - minX;
//     const height = maxY - minY;

//     canvas.width = width;
//     canvas.height = height;

//     ctx?.drawImage(video, minX, minY, width, height, 0, 0, width, height);
//     this.selectedImage = canvas.toDataURL('image/png');
//     console.log("✅ Eye region captured");
//   } else {
//     canvas.width = video.videoWidth;
//     canvas.height = video.videoHeight;
//     ctx?.drawImage(video, 0, 0, canvas.width, canvas.height);
//     this.selectedImage = canvas.toDataURL('image/png');
//     console.warn("⚠️ No face/eyes detected — capturing full image");
//   }

//   this.stopCamera();
// }


  stopCamera() {
    this.showCamera = false;
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
      this.stream = null;
    }
  }
  
  switchCamera() {
    // Switch between 'user' and 'environment'
    this.currentFacingMode = this.currentFacingMode === 'user' ? 'environment' : 'user';

    // Stop only the video tracks before switching
    if (this.stream) {
      this.stream.getVideoTracks().forEach(track => track.stop());
    }

    // Restart camera with new facing mode
    const constraints = {
      video: { facingMode: this.currentFacingMode }
    };

    navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
      this.stream = stream;
      this.video.nativeElement.srcObject = stream;
      this.video.nativeElement.play();
    }).catch((err) => {
      console.error('Error switching camera:', err);
    });
  }


  onImageSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.selectedImage = reader.result;
        this.analysisResult = null; // Clear previous result
      };
      reader.readAsDataURL(file);
    }
  }
  uploadBase64Image(filepayload: any) {
    // return this.http.post<{ result: string }>('http://localhost:3000/analyze-eye-base64', { base64 });
    return this.http.post<{ result: string }>('https://ai-eyescan.elihealthsupport.com/predict', filepayload);

  }

  base64ToFile(base64: string, filename: string): File {
    const arr = base64.split(',');
    const mime = arr[0].match(/:(.*?);/)![1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }


  analyzeImage() {

    // const base64String = (this.selectedImage as string).split(',')[1];

    // const body = { imageBase64: base64String };
    if (!this.selectedImage) return;
    this.autherservice.open_initial_loader_Dialog();
    const base64String = (this.selectedImage as string);
    const formData = new FormData();
    const file = this.base64ToFile(base64String, 'image.png');
    formData.append('file', file);

    this.starttime = new Date().toTimeString().split(" ")[0];
    this.uploadBase64Image(formData).subscribe((data: any) => {
      this.endtime = new Date().toTimeString().split(" ")[0];
      this.dialog.closeAll();
      if (data['detection_found'] == false) {
        this.analysisResult = {
          userName: this.username,
          DetectedObject: '❌ No eye region detected.',
          Confidence: 0,
          Notes: data['message'],

        };
      } else {
        this.analysisResult = {
          userName: this.username,
          DetectedObject: '✅ ' + data['label'],
          Confidence: data['confidence'],
          Notes: '',
        };
      }

    }, err => {
      this.dialog.closeAll();
      if (err.status == 400) {
        this.analysisResult = {
          userName: this.username,
          DetectedObject: '❌ No eye region detected.',
          Confidence: '0',
          Notes: '',
        };

      } else {
        this.autherservice.openSnackBar("API Failed", "ok");
      }

    })


  }

  userSelection: boolean | null = null;

  submitFeedback(isCorrect: boolean) {
    this.userSelection = isCorrect;
    console.log('Prediction correct?', isCorrect);
    // You can also send this to backend here
  }
  submitTextFeedback() {
    if (this.userSelection == true || this.userSelection == false) {
      let payload = {
        "InsertAutoPrediction": {
          "Pk_TranId": 0,
          "ImageType": "Catract",
          "ImageName": "Catract.png",
          "ImageDetails": this.userSelection,
          "ImageURL": "ImageURL1",
          "Result": this.analysisResult.DetectedObject.replace(/[\p{Emoji_Presentation}\p{Emoji}\uFE0F]/gu, '').trim(),
          "Remarks": this.userFeedback || this.analysisResult.Notes,
          "StartTime": this.starttime,
          "EndTime": this.endtime,
          "Fk_CreatedById": this.autherservice.Loggeduser.userid,
          "CreateDateTime": this.datePipe.transform(new Date(), "yyyy-MM-dd"),
          "IsEdit": false
        }
      }
      this.autherservice.aifeedbackstatus(payload).subscribe((x: any) => {

        this.autherservice.openSnackBar("Thanks for your feedback", "ok");
        this.endtime = ''
        this.starttime = '';
        this.userSelection = null;
        this.userFeedback = '';
      })


    } else {
      this.autherservice.openSnackBar("Please select prediction yes or no", "ok");
    }
  }
  showPassword = false;

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
  login() {

    if (this.username && this.password) {
      let payload = {
        "Nam": this.username,
        "Pas": this.password
      }
      this.autherservice.LoginUser(payload).subscribe((x: any) => {
        console.log(x);
        if (x.id == -10) {
          this.showSuccessMessage = false;
          return this.autherservice.openSnackBar("Please Enter valid User Name and Password", 'OK');
        } else if (x.id == -102) {
          this.showSuccessMessage = false;
          return this.autherservice.openSnackBar("Your User Name and Password is locked", 'ok');

        } else if (x['authViewModels'].id > 0) {
          this.autherservice.Loggeduser.token = x['authViewModels'].token;

          this.autherservice.Loggeduser.userid = x['authViewModels'].id;

          sessionStorage.setItem('token', JSON.stringify(this.autherservice.Loggeduser.token));
          this.isLoggedIn = true;
          this.loginSuccess = '✅ Login successful!';
          this.loginError = '';
          this.showSuccessMessage = true;

          setTimeout(() => {
            this.showSuccessMessage = false;
          }, 1000);
        } else {
          this.loginError = '❌ Invalid username or password';
          this.loginSuccess = '';
          this.showSuccessMessage = false;
        }

      })
    } else {
      this.loginError = '❌ Invalid username or password';
      this.loginSuccess = '';
      this.showSuccessMessage = false;
    }

  }
  logout() {
    let payload = {
      "FK_UserId": 0,
      "Token": JSON.parse(sessionStorage.getItem('token')),
      "IsActive": 0,
      "IsLogOutOtherSession": 1,
      "SessionInterval": 0
    };
    this.autherservice.AIlogout(payload).subscribe((item: any) => {
      this.autherservice.Loggeduser = {};
      this.isLoggedIn = false;
      this.username = '';
      this.password = '';
      this.selectedImage = null;
      this.analysisResult = null;
      this.userFeedback = '';
      this.stopCamera();
    });


  }
}
